var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"global_footer"},[_vm._v("© 2020 cortechne, Inc.")])}
var staticRenderFns = []

export { render, staticRenderFns }